import React from 'react';
import { Layout as AntLayout } from 'antd';

/**
 * Wrapper component for Ant Design Layout
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Layout functionality and sub-components.
 * 
 * @component
 * @example
 * import { Layout } from '../GeneralComponents/ui';
 * 
 * <Layout>
 *   <Layout.Header>Header</Layout.Header>
 *   <Layout.Content>Content</Layout.Content>
 *   <Layout.Footer>Footer</Layout.Footer>
 * </Layout>
 * 
 * @see https://ant.design/components/layout/ - Ant Design Layout documentation
 */
const Layout = (props) => {
  return <AntLayout {...props} />;
};

// Preserve Layout sub-components
Layout.Header = AntLayout.Header;
Layout.Content = AntLayout.Content;
Layout.Footer = AntLayout.Footer;
Layout.Sider = AntLayout.Sider;

export default Layout;

